import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getUserShortInfo} from 'src/openapi/admin/apis/GetUserShortInfoApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
};

export const useGetUserShortInfo = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getUserShortInfo({userId}, {signal}),
    ), [userId, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: {
            accountId: 0,
            userId: 0,
            email: '',
            firstName: '',
            lastName: '',
            isDeleted: false,
        },
        getDispatchAction,
    });
};
